import { useEffect } from 'react';

import LoadingIndicator from '~/components/LoadingIndicator/LoadingIndicator';

import { useEntryCondition } from '~/hooks';
import { useLoadingStore } from '~/store';

/**
 * @description - 앱 최초 실행 시 보여지는 페이지
 */
const Entry = ({ isAppTypeChecked = true }: { isAppTypeChecked?: boolean }) => {
  useEntryCondition({ isAppTypeChecked });

  const setLoading = useLoadingStore((state) => state.actions.setLoading);

  useEffect(() => {
    setLoading({ show: true, dimmed: false, zIndex: 9999 });

    return () => {
      setLoading({ show: false });
    };
  }, []);

  return <LoadingIndicator />;
};

export default Entry;
